<template>
  <div v-cloak>
    <div class="page_bg">
    <!-- 顶部导航栏 -->
    <div class="back_box">
      <div class="back_left">
        <div class="back_btn" @click="backPage">
          <i class="el-icon-arrow-left"></i>
          <span>返回</span>
        </div>
        <div class="page_title">
          <span class="class_name">{{ className }}</span>
          <span class="title_sep">/</span>
          {{ isMoKao ? '综合模拟' : '统一考试' }}
        </div>
      </div>
    </div>

    <!-- 考试列表 -->
    <div class="TYKS_page" v-if="pageInfo.length!=0">
      <div class="exam_item" v-for="(item, index) in pageInfo" :key="index">
        <!-- 左侧图片 -->
        <div class="img_box">
          <img src="https://resources.sxsaas.com/static/jigou-saas-app/examDefault.png" alt="" />
        </div>
        <!-- 右侧信息 -->
        <div class="info_box">
          <div class="base_info">
            <div class="title">{{ item.title }}</div>
            <div class="detail">
              <div v-if="!isMoKao" class="detail_item">
                <i class="el-icon-date detail_icon"></i>
                <span>考试时间：{{ item.start_time }}</span>
              </div>
              <div class="detail_item">
                <i class="el-icon-timer detail_icon"></i>
                <span>考试时长：<em>{{ item.exam_duration }}</em> 分钟</span>
              </div>
              <div class="detail_item">
                <i class="el-icon-medal detail_icon"></i>
                <span>合格分数：<em>{{ item.qualified_score }}</em> 分</span>
              </div>
              <div v-if="!isMoKao" class="detail_item">
                <i class="el-icon-document detail_icon"></i>
                <span>已考次数：<em>{{ item.exam_count }}</em> / {{ item.allow_num }} 次</span>
              </div>
              <div v-else class="detail_item">
                <i class="el-icon-document detail_icon"></i>
                <span>已考次数：<em>{{ item.exam_count }}</em> 次</span>
              </div>
            </div>
          </div>
          <div class="subject_info">
            <div class="subject_item">
              <div class="sub_label">总题数</div>
              <div class="sub_count">共{{ item.ques_count }}题</div>
              <div class="sub_score">{{ item.score }}分</div>
            </div>
            <div class="subject_item" v-for="(item2,index2) in item.ques_type" :key="index2">
              <div class="sub_label">{{ item2.title }}</div>
              <div class="sub_count">共{{ item2.ques_count }}题</div>
              <div class="sub_score">{{ item2.score }}分</div>
            </div>
            <div v-if="isMoKao && ce_isCantExercise(item.open_set.set_id) && item.open_set.entry_time"
              class="subject_item next_time">
              <i class="el-icon-warning-outline"></i>
              下次允许进入: {{ item.open_set.entry_time }}
            </div>
          </div>
          <template>
            <div v-if="isMoKao && ce_isCantExercise(item.open_set.set_id)" class="jump_btn disabled">
              <i class="el-icon-lock"></i>
              <span>当前时间不允许模拟考试</span>
            </div>
            <div v-else class="jump_btn" @click="jumpExam(index)" v-throttle>
              <span>进入考试</span>
              <i class="el-icon-arrow-right"></i>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div v-else class="empty_wrap">
      <nullBox></nullBox>
    </div>
    </div>

    <div class="page_end_fixed">
      <endBox></endBox>
    </div>

    <comfirm2 @clickComfirm="cantExerciseComfirm" :data="ce_cantExerciseComfirmData"
      v-if="ce_isShowCantExerciseModal"></comfirm2>
  </div>
</template>

<script>
import { _getExamList} from "../../api/TYKSList"
import * as examinationApi from '@/api/examination.js';
import * as exerciseApi from '@/api/exercise.js';
import * as global from '@/mixins/global.js';
import comfirm2 from "../../components/comfirm2.vue"
import cantExerciseMixin from '@/mixins/cant-exercise.js';

export default {
  mixins: [cantExerciseMixin],
  components: {
    comfirm2
  },
  created() {
    this.getExamList()
  },

  mounted() {},
  data() {
    return {
      pageInfo: [],
      className: window.localStorage.getItem("className") || "",
    };
  },
  computed:{
    isMoKao(){
      return this.$route.query.examType == global.ExamType.MoKao;
    },
  },
  methods: {
    backPage() {
      this.$router.push({ name: 'ExamTab' });
    },
    async getExamList(){
      let params = {
        pro_id: window.localStorage.getItem("proID"),
        load: true,
        isShowErr: true,
      }

      let res;
      //模考
      if(this.isMoKao) {
        res= await examinationApi.getMoExamList(params)
      } else {
        res= await _getExamList(params)
      }
      this.pageInfo =res.data
    },
    jumpExam(index){
      //模考
      if(this.isMoKao) {
        //清除考试缓存
        global.clearExamStorage();
        this.getMoExamQues(this.pageInfo[index].practice_id, this.pageInfo[index].pro_sub_id).then(res=>{
          if (this.ce_isCantExercise(res.set_id)) {
            this.ce_showCantExercisePop(res.set_id);
            return;
          }

          window.sessionStorage.setItem("isCanJumpExam", "true")
          const grantInfo = {
            practice_id:this.pageInfo[index].practice_id,
            pro_sub_id:this.pageInfo[index].pro_sub_id,
            exam_count:this.pageInfo[index].exam_count,
            grant_info: {
              title:this.pageInfo[index].title,
              exam_duration:res.exam_duration,
            }
          };
          window.localStorage.setItem("grantInfo", JSON.stringify(grantInfo))
          this.$router.replace({ name: "TYKSPage",query:{
            examType:global.ExamType.MoKao
          } });
        });
      } else {
        window.localStorage.setItem("grantID", this.pageInfo[index].grant_id)
        this.$router.push({ name: "TYKSStart" });
      }

    },
    async getMoExamQues(practice_id, pro_sub_id) {
      let params = {
        practice_id,
        pro_sub_id,
        load: true,
        isShowErr: true,
      }
      let res = await examinationApi.getMoExamQues(params)
      window.localStorage.setItem("exam_ques", JSON.stringify(res.data))
      window.localStorage.setItem("exam_id", res.data.exam_id)
      return res.data;
    },
    cantExerciseComfirm() {
      // this.$router.back()
      location.reload();
    }
  },
};
</script>
<style scoped>
/* 页面底色 */
.page_bg {
  background: #f5f7fa;
  padding-bottom: 20px;
}

/* ========== 顶部导航 ========== */
.back_box {
  width: 100%;
  max-width: 1160px;
  height: 56px;
  background: #fff;
  margin: 20px auto 18px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 0 24px;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
}

.back_left {
  display: flex;
  align-items: center;
  gap: 18px;
}

.back_btn {
  height: 34px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  background: #f0f2ff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  color: #646eff;
  font-weight: 500;
  transition: all 0.2s;
}

.back_btn:hover {
  background: #e4e7ff;
}

.back_btn i {
  font-size: 13px;
}

.page_title {
  color: #1a1a2e;
  font-weight: 700;
  font-size: 18px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.class_name {
  color: #646eff;
  font-weight: 600;
}

.title_sep {
  color: #dcdfe6;
  font-weight: 400;
}

/* ========== 列表容器 ========== */
.TYKS_page {
  width: 100%;
  max-width: 1160px;
  height: 78vh;
  margin: 0 auto;
  box-sizing: border-box;
  overflow-y: auto;
}

.TYKS_page::-webkit-scrollbar {
  width: 5px;
}

.TYKS_page::-webkit-scrollbar-track {
  background: transparent;
}

.TYKS_page::-webkit-scrollbar-thumb {
  background: #dcdfe6;
  border-radius: 3px;
}

/* ========== 考试卡片 ========== */
.exam_item {
  width: 100%;
  background: #fff;
  box-sizing: border-box;
  padding: 20px 24px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
  border-radius: 10px;
  border: 1px solid #eef0f5;
  transition: all 0.25s;
}

.exam_item:hover {
  border-color: #d8dcf0;
  box-shadow: 0 4px 20px rgba(100, 110, 255, 0.08);
  transform: translateY(-1px);
}

/* 左侧图片 */
.exam_item .img_box {
  width: 320px;
  height: 240px;
  flex-shrink: 0;
  border-radius: 8px;
  overflow: hidden;
  background: #f5f6f8;
}

.exam_item .img_box img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* ========== 右侧信息区 ========== */
.info_box {
  flex: 1;
  box-sizing: border-box;
  padding-left: 24px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
}

/* 标题 */
.info_box .base_info .title {
  color: #1a1a2e;
  font-weight: 700;
  font-size: 22px;
  margin-bottom: 10px;
  padding-left: 12px;
  border-left: 3px solid #646eff;
}

/* 考试信息行 */
.info_box .base_info .detail {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 8px;
  padding-right: 140px;
}

.detail_item {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 4px 10px;
  background: #f7f8fa;
  border-radius: 6px;
  color: #606266;
  font-size: 13px;
}

.detail_icon {
  color: #646eff;
  font-size: 13px;
  opacity: 0.7;
}

.detail_item em {
  font-style: normal;
  font-weight: 600;
  color: #646eff;
}

/* ========== 题型信息 ========== */
.subject_info {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 10px;
}

.subject_item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 10px;
  background: #f7f8fa;
  border-radius: 6px;
  font-size: 13px;
  color: #606266;
}

.subject_item .sub_label {
  color: #909399;
}

.subject_item .sub_count {
  color: #606266;
  font-weight: 500;
}

.subject_item .sub_score {
  color: #646eff;
  font-weight: 600;
}

.subject_item.next_time {
  width: 100%;
  background: #fff8eb;
  color: #e6a23c;
  gap: 4px;
  margin-top: 2px;
}

.subject_item.next_time i {
  font-size: 13px;
}

/* ========== 进入按钮 ========== */
.jump_btn {
  height: 40px;
  padding: 0 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  flex-shrink: 0;
  box-sizing: border-box;
  border-radius: 8px;
  background: linear-gradient(135deg, #646eff, #7b83ff);
  cursor: pointer;
  color: #fff;
  font-weight: 600;
  font-size: 15px;
  position: absolute;
  right: 0;
  bottom: 0;
  transition: all 0.25s;
  box-shadow: 0 3px 12px rgba(100, 110, 255, 0.25);
}

.jump_btn:hover {
  background: linear-gradient(135deg, #5560e8, #6c74f0);
  box-shadow: 0 4px 18px rgba(100, 110, 255, 0.35);
  transform: translateY(-1px);
}

.jump_btn i {
  font-size: 13px;
}

.jump_btn.disabled {
  width: auto;
  padding: 0 20px;
  background: #c0c4cc;
  box-shadow: none;
  cursor: not-allowed;
  gap: 6px;
  font-size: 13px;
}

.jump_btn.disabled:hover {
  transform: none;
  box-shadow: none;
  background: #c0c4cc;
}

.jump_btn.disabled i {
  font-size: 13px;
}

/* ========== 空状态 ========== */
.empty_wrap {
  display: flex;
  justify-content: center;
  padding-top: 80px;
}

/* ========== 小屏适配 ========== */
@media (max-width: 1200px) {
  .back_box,
  .TYKS_page {
    width: 94%;
  }

  .exam_item .img_box {
    width: 280px;
    height: 210px;
  }
}

@media (max-width: 1024px) {
  .back_box {
    height: auto;
    padding: 12px 18px;
  }

  .back_left {
    gap: 12px;
  }

  .page_title {
    font-size: 16px;
  }

  .exam_item {
    padding: 16px 18px;
  }

  .exam_item .img_box {
    width: 240px;
    height: 180px;
  }

  .info_box {
    padding-left: 18px;
  }

  .info_box .base_info .title {
    font-size: 19px;
  }

  .info_box .base_info .detail {
    padding-right: 120px;
  }
}

@media (max-width: 768px) {
  .back_box {
    padding: 10px 14px;
    border-radius: 6px;
  }

  .back_left {
    gap: 10px;
  }

  .back_btn {
    height: 30px;
    padding: 0 12px;
    font-size: 13px;
  }

  .page_title {
    font-size: 15px;
    gap: 6px;
  }

  .TYKS_page {
    height: auto;
    min-height: 70vh;
  }

  .exam_item {
    flex-direction: column;
    padding: 14px;
    border-radius: 8px;
  }

  .exam_item .img_box {
    width: 100%;
    height: 180px;
    margin-bottom: 14px;
  }

  .info_box {
    padding-left: 0;
  }

  .info_box .base_info .title {
    font-size: 18px;
    margin-bottom: 8px;
  }

  .info_box .base_info .detail {
    padding-right: 0;
    gap: 8px;
  }

  .detail_item {
    padding: 3px 8px;
    font-size: 12px;
  }

  .subject_info {
    gap: 8px;
    margin-top: 8px;
  }

  .subject_item {
    padding: 3px 8px;
    font-size: 12px;
    gap: 6px;
  }

  .jump_btn {
    position: static;
    width: 100%;
    margin-top: 12px;
    border-radius: 6px;
    font-size: 14px;
    height: 38px;
  }

  .jump_btn.disabled {
    width: 100%;
  }
}
</style>
